export enum ZIndex {
    Highest = 300,
    Higher = 200,
    High = 100,
    Normal = 1,
}
